// extracted by mini-css-extract-plugin
export default {"summary-container":"MedicineWiseStockRequestReportSummary_summary-container__VGK+v","summary-ctas":"MedicineWiseStockRequestReportSummary_summary-ctas__7ccq1"};